import Loader from 'Lib/utilities/Loader';

const routes = [
	{
		path: '/settings',
		component: Loader(() => import('~/containers/settings/View'))
	}
];

export default routes;
